import { MobileTitle } from '../../components/Title'
// import { Tweet, Timeline } from 'react-twitter-widgets'
export const ContestPutty = () => {
    return (
        <>
            <div className='py-12 w-full text-center mx-auto'>
                <span className='newicon-mobilenav relative pt-2'>
                    <h1 className='md:hidden text-gradient-title text-xlg font-pop inline-block'>Contest</h1>{' '}
                </span>
            </div>
            <div className='px-4 max-w-[1200px] mx-auto'>
                <div className='flex justify-center mt-8'>
                    <img
                        alt='Putty Adventures Contest'
                        src={`${process.env.PUBLIC_URL}/images/contest/contest-header-putty.webp`}
                    />
                </div>{' '}
                <section className='mt-12 mb-20'>
                    <h3 className='text-center text-gradient-title text-xlg font-pop'>Winners Announced!</h3>{' '}
                    <div className='text-shadow-white text-pbnavy font-kiwi font-bold text-sub md:text-base mx-auto text-center w-full md:w-4/5 mt-12'>
                        <p className=''>We're thrilled to reveal the winners of the Putty Adventures Photo Contest!</p>{' '}
                        <p>
                            Thank you to everyone who participated and showcased their forest-dwelling Putty Plush or
                            Paper Putty adventuring in the wild!
                        </p>
                    </div>{' '}
                    <div className=' space-y-12 text-shadow-white text-pbnavy font-kiwi font-bold text-sub md:text-base mx-auto text-center w-full md:w-4/5 mt-12'>
                        <div className='max-w-[680px] mx-auto py-4'>
                            <img
                                className='text-center'
                                alt='Putty Adventures Contest'
                                src={`${process.env.PUBLIC_URL}/images/contest/winner1.webp`}
                            />
                        </div>{' '}
                        <div className='max-w-[680px] mx-auto py-4'>
                            <img
                                className=''
                                alt='Putty Adventures Contest'
                                src={`${process.env.PUBLIC_URL}/images/contest/winner2.webp`}
                            />
                        </div>{' '}
                        <p className='mt-20'>Congratulations again to our winners!</p>
                    </div>
                </section>
                <div className='border-t-2 border-pbbrown'></div>
                <div className='text-shadow-white text-pbnavy font-kiwi font-bold text-sub md:text-base mx-auto text-center w-full md:w-4/5 mt-12'>
                    <p className=''>
                        The forest-dwelling Putty are embarking on an adventure to celebrate the upcoming release of
                        <span className='text-pbdarkorange'> Phantom Brave: The Lost Hero </span>
                        on January 30, 2025 and{' '}
                        <a target='_blank' rel='noreferrer' href='https://nisamerica.com/phantombrave-remastered/'>
                            <span className='text-cyan-600 hover:brightness-110 duration-300'>
                                Phantom Brave: The Hermuda Triangle Remastered
                            </span>
                        </a>{' '}
                        on PS5 on November 7, 2024! Where will they turn up next?
                    </p>
                    <p>
                        Snap a photo of your Putty sighting and share it using the hashtag #PuttyAdventures on X to be
                        entered to win a Pocket-Sized Putty Plush!{' '}
                    </p>{' '}
                </div>{' '}
                <img
                    className='w-3/5 max-w-[300px] mx-auto my-12 cursor-pointer  border-pborange'
                    alt='Putty plushie'
                    src={`${process.env.PUBLIC_URL}/images/contest/Putty_Front_900x900.png`}
                />{' '}
                {/* <div className='w-3/5 mx-auto flex flex-row'>
                    <div className='w-1/2 flex flex-col'>
                        <div className='bg-cyan-400'>
                            <p className='text-white'>Prize</p>
                        </div>{' '}
                        <div className=''>
                            <p className='text-cyan-400 font-kiwi font-bold text-sub md:text-base'>
                                Pocket-Sized Putty Plush
                            </p>
                        </div>
                    </div>
                    <div className='w-1/2'>
                        <img
                            className='product-glow mx-auto  cursor-pointer  border-pborange'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/contest/Putty_Front_900x900.png`}
                        />{' '}
                    </div>
                </div> */}
                <div className='flex flex-col md:flex-col justify-center my-4 md:mb-20 md:mt-12 gap-16'>
                    <div className='w-full mx-auto md:w-4/5'>
                        <div className='font-kiwi font-bold text-sub md:text-sm mx-auto '>
                            <h3 className='text-center text-gradient-title text-lg font-pop'>Contest Period </h3>{' '}
                            <p className='text-shadow-white text-pbnavy my-8 text-center'>
                                September 27, 2024 (10:00am PDT) - December, 27, 2024 (11:59pm PST)
                            </p>
                        </div>{' '}
                        <div className='font-kiwi  text-sub md:text-sm mx-auto '>
                            <h3 className='text-center text-gradient-title text-lg font-pop'>How to Enter</h3>{' '}
                            <div className='flex flex-col justify-center align-middle items-center mt-8 gap-8'>
                                <div className='w-full'>
                                    <ol className='text-shadow-white text-pbnavy  pl-6 w-full list-decimal list-outside'>
                                        <li>
                                            <div className='flex flex-col md:flex-row my-8 justify-center gap-8 '>
                                                <div className='w-full md:w-4/5  mt-4 mx-auto'>
                                                    <p className='text-shadow-white text-pbnavy'>
                                                        Download, print, and cut out your Paper Putty or grab your
                                                        event-exclusive Putty Plush.
                                                    </p>{' '}
                                                    <p className='mt-4'>
                                                        When printing your Paper Putty, resize the image in your
                                                        printing settings to get your Putty to the desired size.
                                                    </p>
                                                </div>
                                                <div className='w-3/5 mx-auto md:w-2/5 rounded-lg border-4 border-pborange hover:scale-105 hover:brightness-125 duration-300'>
                                                    <a
                                                        href={`${process.env.PUBLIC_URL}/images/contest/putty-cutout.jpg`}
                                                        download
                                                    >
                                                        <span>
                                                            <img
                                                                className='no-hover-effect rounded-md w-full mx-auto  cursor-pointer  border-pborange'
                                                                alt='putty cutout'
                                                                src={`${process.env.PUBLIC_URL}/images/contest/putty-cutout.jpg`}
                                                            />{' '}
                                                        </span>
                                                        <div className='font-pop text-center bg-pborange  text-pborange w-full'>
                                                            Click here to download
                                                        </div>
                                                    </a>{' '}
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <p>
                                                Take a photo of Paper Putty / Putty Plush out and about - whether it's
                                                in your room, your neighborhood, your local hangout, or somewhere even
                                                more scenic!
                                            </p>{' '}
                                            <img
                                                className='w-4/5 mx-auto my-12 border-white border-2'
                                                alt='putty in japan'
                                                src={`${process.env.PUBLIC_URL}/images/contest/putty-in-japan.webp`}
                                            />{' '}
                                        </li>{' '}
                                        <li>
                                            <p>
                                                Post the photo on X. Be sure to tag{' '}
                                                <a
                                                    className='text-blue-400 cursor-pointer'
                                                    href='https://twitter.com/NISAmerica'
                                                >
                                                    @NISAmerica
                                                </a>{' '}
                                                and use{' '}
                                                <span className='text-blue-400 cursor-pointer'>#PuttyAdventures</span>{' '}
                                                in the caption.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                To be eligible to win, you must be following{' '}
                                                <a
                                                    className='text-blue-400 cursor-pointer'
                                                    href='https://twitter.com/NISAmerica'
                                                >
                                                    @NISAmerica
                                                </a>{' '}
                                            </p>
                                        </li>
                                    </ol>{' '}
                                </div>{' '}
                            </div>
                        </div>{' '}
                        <div className=' font-kiwi font-bold text-sub md:text-sm mx-auto mt-12'>
                            <h3 className='text-center text-gradient-title text-lg font-pop'>Entry Eligibility</h3>{' '}
                            <ul className='text-shadow-white text-pbnavy pl-6 w-full list-disc list-outside mt-8'>
                                <li>
                                    <p>
                                        Open only to individuals who are legal residents of the fifty (50) United States
                                        (including the District of Columbia) and Canada (excluding Quebec) and are 18
                                        years of age or older.
                                    </p>
                                </li>
                            </ul>
                        </div>{' '}
                        <div className=' text-pbnavy font-kiwi font-bold text-sub md:text-sm mx-auto my-12'>
                            <div className='font-kiwi font-bold text-sub md:text-sm mx-auto mt-12'>
                                <h3 className='text-center text-gradient-title text-lg font-pop'>Notifying a Winner</h3>{' '}
                                <ul className='text-shadow-white text-pbnavy pl-6 w-full list-disc list-outside mt-8'>
                                    <li>
                                        <p>
                                            Winners will be selected through a random drawing among all eligible
                                            entries.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Winners will be notified by or about January 6, 2025 via direct message on
                                            X. Please ensure your account is set to receive direct messages.
                                        </p>
                                    </li>{' '}
                                    <li>
                                        <p>
                                            Winners shall have 7 days to claim their prize. If unclaimed, they will
                                            forfeit their prize and another winner shall be randomly selected.
                                        </p>
                                    </li>{' '}
                                    <li>
                                        <p>
                                            Please view{' '}
                                            <a
                                                className='text-blue-400 cursor-pointer'
                                                href='https://www.nisamerica.com/contests'
                                            >
                                                here
                                            </a>{' '}
                                            for the complete list of contest rules and regulations.
                                        </p>
                                    </li>
                                </ul>
                            </div>{' '}
                        </div>
                    </div>
                </div>{' '}
            </div>
        </>
    )
}
